import { OpenCommerceUserFragment } from '@occc/graphql';

import { PreparedUser } from './types';

export const prepareUserData = (user: OpenCommerceUserFragment | null): PreparedUser | null => {
  if (!user) {
    return null;
  }

  const { name, userRole, email } = user;
  const nameFirstLetter = name.first?.charAt(0) || '';
  const lastNameFirstLetter = name.last?.charAt(0) || '';
  const avatarLetters = `${nameFirstLetter}${lastNameFirstLetter}`;
  return { name, email, avatarLetters, userRole };
};
